// Minimal client-side JWT helpers (decode-only; NEVER trusts the token for
// authorization — only used to schedule the pre-expiry warning + proactive
// expiry transition so we don't wait for an API call to fail).

const b64UrlDecode = (str) => {
  try {
    const pad = str.length % 4 ? '='.repeat(4 - (str.length % 4)) : '';
    const b64 = (str + pad).replace(/-/g, '+').replace(/_/g, '/');
    return decodeURIComponent(
      atob(b64)
        .split('')
        .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join('')
    );
  } catch {
    return null;
  }
};

export const decodeJwt = (token) => {
  if (!token || typeof token !== 'string') return null;
  const parts = token.split('.');
  if (parts.length !== 3) return null;
  const json = b64UrlDecode(parts[1]);
  if (!json) return null;
  try {
    return JSON.parse(json);
  } catch {
    return null;
  }
};

// Returns the token expiry as epoch milliseconds, or null if unavailable.
export const getTokenExpiryMs = (token) => {
  const payload = decodeJwt(token);
  if (!payload || typeof payload.exp !== 'number') return null;
  return payload.exp * 1000;
};
